import { useSiteConfig } from "../../App";
import styles from "./Sponsors.module.scss";
import imageUrlBuilder from "@sanity/image-url";
import sanityClient from "../../api/sanityClient";

const builder = imageUrlBuilder(sanityClient);
const urlFor = (source) => builder.image(source);

const Sponsors = () => {
  const siteConfig = useSiteConfig();
  if (!siteConfig) return <div className={styles.sponsorsGrid}> Loading Sponsors...</div>;
  const sponsors = siteConfig.sponsors;

  return (
    <div className={styles.sponsorsGrid}>
      {sponsors
        ? sponsors.map((sponsor, index) => (
            <img
              key={index}
              src={urlFor(sponsor.asset).url()}
              alt={`Sponsor ${index + 1}`}
              className={styles.sponsorLogo}
            />
          ))
        : ""}
    </div>
  );
};

export default Sponsors;
